











import Vue from "vue";
import Multiselect from "vue-multiselect";
import AuthenticationService from "./services/AuthenticationService";
import AuthenticationServiceFactory from "./services/AuthenticationServiceFactory";
import HttpClient from "./services/HttpClient";
import HttpClientFactory from "./services/HttpClientFactory";
import { mapActions } from "vuex";

Vue.component("multiselect", Multiselect);
export default Vue.extend({
  data() {
    return {
      httpClient: {} as HttpClient,
      authenticationService: {} as AuthenticationService,
      // 13-10-2021 => Temporary solution until we have a real single page application
      isAppInitialized: false,
    };
  },
  watch: {
    $route: {
      handler: function () {
        document.title = this.getTitle();
      },
      immediate: true,
    },
  },
  async created() {
    this.httpClient = HttpClientFactory.getInstance();
    this.authenticationService = AuthenticationServiceFactory.getInstance();
    const token = this.authenticationService.getAuthTokenFromStorage();

    if (token === null) {
      this.isAppInitialized = true;
      return;
    }

    this.httpClient.setToken(token);

    await this.loadUser();
    this.isAppInitialized = true;
  },
  methods: {
    ...mapActions("auth", ["loadUser"]),
    getTitle() {
      return (
        this.$t("router:titles." + this.$route.meta.title) + " | " + "Mandaa"
      );
    },
  },
});
